var classes = {"tab":"YhILP","tabHorizontal":"exTIC","tabVertical":"_2ShWU"};

export { classes as default };
